<template>
  <data-analysis-quotes-selector @filterConfig="onFilterConfig">
    <template #header>
      <div class="col-md-12 mb-3 row no-gutters">
        <div class="col">
        </div>
        <div class="col-6 text-center">
          <h2>Analys</h2>
        </div>
        <div class="col">
          <a v-if="excelExportUrl !== null" class="btn btn-primary float-right" :href="excelExportUrl"><i class="fal fa-file-excel"></i> Exportera </a>
        </div>
      </div>
    </template>

    <template #after-filters>
      <div v-if="isLoaded" class="card mb-4">
        <div class="card-header">Sammanställning</div>
        <div class="card-body">
          <div v-if="isLoaded" class="row">
            <div class="col-md-4 text-center">
              <h5>Antal</h5>
              <p>{{count}}</p>
            </div>
            <div class="col-md-4 text-center">
              <h5>Medelvärde</h5>
              <p>{{average}}</p>
            </div>
            <div class="col-md-4 text-center">
              <h5>Summa</h5>
              <p>{{sum}}</p>
            </div>
          </div>
          <div v-else class="text-center">
            <SbSpinner label="Laddar.." />
          </div>
        </div>
      </div>
    </template>
  </data-analysis-quotes-selector>
</template>

<style lang="scss" scoped>
</style>

<script setup lang="ts">
import axios from 'axios';
import { ref } from 'vue';
import { route } from 'ziggy-js';
import SbSpinner from '../sb/SbSpinner.vue';

interface FilterConfig { [key: string]: unknown }
const formatter = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' });
const isLoaded = ref(false);
const count = ref<number | null>(null);
const sum = ref<string | null>(null);
const average = ref<string | null>(null);
const excelExportUrl = ref<string | null>(null);
function setExcelExportUrl(filterConfig: FilterConfig): string { return route('data_analysis.quotes.export.excel', { _query: { filter_config: filterConfig } }); }
async function onFilterConfig(filterConfig: FilterConfig): Promise<void> {
    isLoaded.value = false;
    const { data: stats } = await axios.get(route('data_analysis.quotes.stats', { _query: { filter_config: filterConfig } }));
    count.value = stats.count;
    sum.value = formatter.format(stats.sum);
    average.value = formatter.format(stats.count !== 0 ? Math.round(stats.sum / stats.count) : 0);
    excelExportUrl.value = setExcelExportUrl(filterConfig);
    isLoaded.value = true;
}
</script>
